var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64873 2.73049L3.31455 4.3558C2.92489 4.50167 2.6665 4.87674 2.6665 5.29349V9.98398C2.6665 10.3632 2.88113 10.7091 3.21869 10.8779L7.55287 13.045C7.83418 13.1867 8.16549 13.1867 8.4468 13.045L12.781 10.8779C13.1206 10.7091 13.3332 10.3611 13.3332 9.98398V5.29349C13.3332 4.87674 13.0748 4.50375 12.6851 4.35789L8.35095 2.73257C8.1259 2.64506 7.87585 2.64506 7.64873 2.73049ZM8.00088 3.31185L12.6685 5.06219V5.06844L8.00088 7.09175L3.3333 5.06844V5.06219L8.00088 3.31185ZM3.3333 5.79567L7.66748 7.67312V12.3553L3.3333 10.1882V5.79567ZM8.33428 12.3553V7.67312L12.6685 5.79567V10.1903L8.33428 12.3553Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
export default __webpack_public_path__ + "97120/static/media/Component.d40c19bf09e3e8e4a4245014b13774a3.svg";
export { ForwardRef as ReactComponent };